//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config/index';
import { recoveryIdentity, updatePasswordForIdentity } from '@data/login';
export default {
  name: 'certificate-retrieval',
  data: function data() {
    var _this = this;

    var verifyMsgNum = function verifyMsgNum(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入验证码！'));
      } else {
        if (value.length == 4) {
          _this.isVerifyMsg = false;
        } else {
          _this.isVerifyMsg = true;
        }

        callback();
      }
    };
    /*模块二验证两次密码输入的是否一致*/


    var verifyEnterPwd = function verifyEnterPwd(rule, value, callback) {
      //            let pattern = /^(\w){6,30}$/;
      if (value === '') {
        callback(new Error('请输入密码！'));
      } else if (!_this.tools.passwordVerify(value)) {
        callback(new Error(_this.msg.WARNING_5));
      } else {
        callback();
      }
    };

    var verifyAgainEnterPwd = function verifyAgainEnterPwd(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码！'));
        _this.isReset = true;
      } else if (value !== _this.resetObj.enterPWD) {
        callback(new Error('两次输入密码不一致！'));
        _this.isReset = true;
      } else {
        callback();
        _this.isReset = false;
      }
    };

    return {
      baseUrl: config.baseUrl,
      captcha: '',
      url: '',
      urlFlag: true,
      isClick: true,
      //按钮置灰
      isVerifyMsg: true,
      //未填写验证码，禁用“确定”按钮
      verifyIdentidy: true,
      //默认在第一个模块--验证身份
      resetPWD: false,
      //第二个模块--修改密码
      getSuccess: false,
      //第三个模块--找回成功

      /*模块一*/
      PWDObj: {
        account: '',
        sid: '',
        name: '',
        sex: 1,
        captcha: '',
        uniquekey: ''
      },
      PWDObjRules: {
        account: [{
          required: true,
          message: '请输入要找回密码的账号',
          trigger: 'blur'
        }],
        sid: [{
          required: true,
          message: '家长用户请输入自己孩子的学籍号',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '家长用户请输入自己孩子的姓名',
          trigger: 'blur'
        }],
        sex: [{
          required: true,
          message: '请选择性别',
          trigger: 'change'
        }],
        captcha: [{
          required: true,
          validator: verifyMsgNum,
          trigger: 'change'
        }]
      },

      /*模块二*/
      isReset: true,
      //重置密码模块，两次输入的密码一致，“确定”按钮可点击
      resetObj: {
        enterPWD: '',
        againEnterPWD: ''
      },
      resetRules: {
        enterPWD: [{
          required: true,
          trigger: 'blur',
          validator: verifyEnterPwd,
          min: 6,
          max: 30
        }],
        againEnterPWD: [{
          required: true,
          trigger: 'blur',
          validator: verifyAgainEnterPwd,
          min: 6,
          max: 30
        }]
      },
      btnFlag: false
    };
  },
  mounted: function mounted() {
    this.url = this.baseUrl + 'captcha?number=' + Math.random();
  },
  watch: {
    'resetObj.enterPWD': function resetObjEnterPWD() {
      if (this.tools.passwordVerify(this.resetObj.enterPWD) && this.resetObj.enterPWD === this.resetObj.againEnterPWD && this.resetObj.enterPWD !== '' && this.resetObj.againEnterPWD !== '') {
        this.isReset = false;
      } else {
        this.isReset = true;
      }
    },
    'resetObj.againEnterPWD': function resetObjAgainEnterPWD() {
      if (this.tools.passwordVerify(this.resetObj.enterPWD) && this.resetObj.enterPWD === this.resetObj.againEnterPWD && this.resetObj.enterPWD !== '' && this.resetObj.againEnterPWD !== '') {
        this.isReset = false;
      } else {
        this.isReset = true;
      }
    }
  },
  methods: {
    //        checkName(val) {
    //            let pattern = /^(\w){6,30}$/;
    //            return !!pattern.exec(val);
    //        },
    //        checkPassword(val) {
    //            let pattern = /^(\w){6,30}$/;
    //            return !!pattern.exec(val);
    //        },
    //验证码失去焦点事件
    captchaBlur: function captchaBlur() {
      debugger;
      var reg = /^\w{4}$/;

      if (this.captcha == '' || this.captcha == undefined || this.captcha == null) {
        // this.isCaptchaMessage = '请输入验证码！';
        this.isCaptcha = true;
      } else if (!reg.test(this.captcha)) {
        // this.isCaptchaMessage = '请输入正确的11位手机号码！';
        this.isCaptcha = true;
      } else {
        this.isCaptcha = false;
      }

      if (!this.isAccount && !this.isPassword && !this.isCaptcha && this.account !== '' && this.password !== '' && this.captcha !== '') {
        this.btnFlag = true;
      } else {
        this.btnFlag = false;
      }
    },
    //按下键盘校验按钮
    keyupFlag: function keyupFlag() {
      var reg = /^\w{4}$/;

      if (this.tools.userNameVerify(this.account) && this.tools.passwordVerify(this.password) && reg.test(this.captcha) && this.account !== '' && this.password !== '' && this.captcha !== '') {
        this.btnFlag = true;
      } else {
        this.btnFlag = false;
      }
    },
    //验证码刷新方法
    yzm: function yzm() {
      var _this2 = this;

      this.url = this.baseUrl + 'captcha?number=' + Math.random();
      this.urlFlag = false;
      setTimeout(function () {
        _this2.urlFlag = true;
      }, 10);
    },
    //模块一：身份验证信息发送
    confirmSendInfoFn: function confirmSendInfoFn(formName) {
      var self = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          recoveryIdentity(self.PWDObj).then(function (res) {
            self.verifyIdentidy = false;
            self.resetPWD = true;
            self.PWDObj.uniquekey = res.uniquekey;
          }).catch(function () {});
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //模块二：发送重置密码
    resetPWDFn: function resetPWDFn() {
      var self = this;
      var params = {
        uniquekey: self.PWDObj.uniquekey,
        password: self.resetObj.enterPWD
      };
      updatePasswordForIdentity(params).then(function () {
        self.verifyIdentidy = false;
        self.resetPWD = false;
        self.getSuccess = true;
      }).catch(function () {});
    },
    toLogin: function toLogin() {
      this.$router.push('/login');
    }
  }
};